export const ORDER_STATUS = {
  CREATED: 'created',
  PENDING: 'pending',
  RECEIVED: 'received',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REJECTED: 'rejected'
}
